import { create } from 'zustand';

import type { SnackbarStore } from './types';

export const useSnackbarStore = create<SnackbarStore>((set) => ({
  message: null,
  severity: 'success',
  isOpen: false,
  show: ({ message, severity = 'success' }) => set({ message, severity, isOpen: true }),
  hide: () => set({ isOpen: false }),
}));
